export default __webpack_public_path__ + "assets/36d114c5ea818927a3ecfe55e9dc1b56.webp";